import { http } from "@/utils/http";
import { handleTree } from "@/utils/tree";
import { useUserStoreHook } from "@/store/modules/user";

type Result = {
  success: boolean;
  data: Array<any>;
};

export const getAsyncRoutes = () => {
  function addMeta(list: Array<any>) {
    list.forEach(child => {
      if (child.component) {
        child.component = child.component.replace("@", "/src");
      }
      child.meta = {
        title: child.menuName,
        showLink: child.menuType != 1,
        icon: child.icon,
        rank: child.menuSort
      };
      child.name = child.menuName;
      if (child.children?.length) {
        addMeta(child.children);
      }
    });
  }
  return new Promise(resolve => {
    http.request<Result>("get", `api/v1/cms/getMenuByUser2`).then(res => {
      const btnsPerm = [];
      const menus = [];
      res.data.forEach(i => {
        if (i.menuType == 1 || (i.path === "/welcome" && !i.menuStatus)) {
          btnsPerm.push(i);
        }
        if (i.menuType != 1 && i.path !== "/welcome" && !i.menuStatus) {
          menus.push(i);
        }
      });
      useUserStoreHook().SET_PERMS(btnsPerm.map(i => i.path));
      addMeta(menus);
      const tree = handleTree(menus);
      console.error("tree", tree);
      tree.forEach(item => {
        if (item.children?.length) {
          item.children = item.children.sort((a, b) => a.menuSort - b.menuSort);
        }
      });
      resolve({ data: tree });
    });
  });
  // return http.request<Result>("get", `api/v1/cms/getRoleList?roleId=${roleId}`);
};
